import Breadcrumb from "components/common/Breadcrumb";
import { DangerAlert } from "components/common/Alerts";
import CustomerSelect from "components/common/CustomerSelect";
import "components/common/DatePicker.css";
import ContentLoading from "components/common/ContentLoading";
import ProductSelect from "components/common/ProductSelect";
import { Base64 } from "js-base64";
import * as moment from "moment";
import * as numeral from "numeral";
import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { Option } from "react-select";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";


interface Props {
    query?: string;
}

interface QuerySearch {
    quoteId?: string;
    fromDate?: string;
    toDate?: string;
    customerId?: number;
    customerName?: string;
    job?: string;
    city?: string;
    productId?: number;
    productName?: string;
    includeArchived: boolean;
}

interface State {
    isLoading: boolean;
    quoteId?: string;
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    customer?: Option;
    job?: string;
    city?: string;
    product?: Option;
    includeArchived: boolean;
    errorMessage?: string;
    results?: SearchResult[];
}

interface SearchResult {
    quoteId: number;
    salesPerson?: string;
    quoteDate: Date;
    customer?: string;
    job: string;
    city?: string;
    state?: string;
    price: number;
}

export default class Index extends React.Component<
    RouteComponentProps<Props>,
    State
> {
    public constructor(props: RouteComponentProps<Props>) {
        super(props);

        this.state = {
            isLoading: this.props.match.params.query !== undefined,
            includeArchived: false,
            errorMessage: undefined,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleBooleanInputChanged = this.handleBooleanInputChanged.bind(this);
        this.handleFromDateChanged = this.handleFromDateChanged.bind(this);
        this.handleToDateChanged = this.handleToDateChanged.bind(this);
        this.handleCustomerSelected = this.handleCustomerSelected.bind(this);
        this.handleProductSelected = this.handleProductSelected.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb />
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <div className="box-wrap">
                        <div className="card-block">
                            <form
                                id="add-job"
                                name="form"
                                className="form"
                                onSubmit={this.handleSubmit}
                            >
                                <h3 className="block-title">Search</h3>
                                <div className="form-wrapper">
                                    <div className="row">
                                        <div className="field-group col-sm-12 d-flex align-items-center">
                                            <span className="field-label mr-2">Quote ID</span>
                                            <input
                                                type="text"
                                                name="quoteId"
                                                className="form-control"
                                                onChange={this.handleInputChanged}
                                                value={this.state.quoteId}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6 d-flex align-items-center datepicker-full-width">
                                            <span className="field-label mr-2">From</span>
                                            <div style={{ width: '72%' }}>
                                                <DatePicker
                                                    name="fromDate"
                                                    selected={this.state.fromDate}
                                                    onChange={this.handleFromDateChanged}
                                                    dateFormat="LL"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    className="form-control"
                                                    popperPlacement="bottom"
                                                    popperModifiers={{
                                                        flip: {
                                                            behavior: ["bottom"],
                                                        },
                                                        preventOverflow: {
                                                            enabled: false,
                                                        },
                                                        hide: {
                                                            enabled: false,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="field-group col-sm-6 d-flex align-items-center datepicker-full-width">
                                            <span className="field-label mr-2">To</span>
                                            <div style={{ width: '72%' }}>
                                                <DatePicker
                                                    name="toDate"
                                                    selected={this.state.toDate}
                                                    onChange={this.handleToDateChanged}
                                                    dateFormat="LL"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    className="form-control"
                                                    popperPlacement="bottom"
                                                    popperModifiers={{
                                                        flip: {
                                                            behavior: ["bottom"],
                                                        },
                                                        preventOverflow: {
                                                            enabled: false,
                                                        },
                                                        hide: {
                                                            enabled: false,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Customer</span>
                                            <CustomerSelect
                                                onItemSelect={this.handleCustomerSelected}
                                                value={this.state.customer}
                                            />
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Project Name</span>
                                            <input
                                                type="text"
                                                name="job"
                                                className="form-control"
                                                style={{ width: '71%' }}
                                                onChange={this.handleInputChanged}
                                                value={this.state.job}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">City</span>
                                            <input
                                                type="text"
                                                name="city"
                                                className="form-control"
                                                style={{ width: '71%' }}
                                                onChange={this.handleInputChanged}
                                                value={this.state.city}
                                            />
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Item</span>
                                            <ProductSelect
                                                onItemSelect={this.handleProductSelected}
                                                value={this.state.product}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6 mt-2 mb-2">
                                            <span className="field-label mt-0">Include Archived</span>
                                            <p className="custom-checkbox-wrap">
                                                <input
                                                    className="custom-checkbox"
                                                    id="include-archived-yes"
                                                    name="includeArchived"
                                                    type="radio"
                                                    value="true"
                                                    onChange={this.handleBooleanInputChanged}
                                                    checked={this.state.includeArchived}
                                                />
                                                <label htmlFor="include-archived-yes">Yes</label>
                                            </p>
                                            <p className="custom-checkbox-wrap">
                                                <input
                                                    className="custom-checkbox"
                                                    id="include-archived-no"
                                                    name="includeArchived"
                                                    type="radio"
                                                    value="false"
                                                    onChange={this.handleBooleanInputChanged}
                                                    checked={!this.state.includeArchived}
                                                />
                                                <label htmlFor="include-archived-no">No</label>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="form-actions">
                                        <div className="text-center">
                                            <button type="submit" className="btn btn-primary">
                                                <span className="btn__animated-icon">
                                                    <i className="icon-search1"></i>
                                                </span>{" "}
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {this.state.results && (
                        <div className="card card--datatables pb-4 mb-0">
                            <div className="card-block">
                                <h2 className="card__title">
                                    {this.state.results.length}{" "}
                                    {this.state.results.length === 1 ? "Result" : "Results"} Found
                                </h2>
                                {this.state.results.length !== 0 ? (
                                    <table className="table table-responsive">
                                        <thead>
                                            <tr>
                                                <th>Salesperson</th>
                                                <th>Quote Date</th>
                                                <th>Quote ID</th>
                                                <th>Customer</th>
                                                <th>Project</th>
                                                <th>City, State</th>
                                                <th>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.results.map(
                                                (item: SearchResult, index: number) => (
                                                    <tr key={index}>
                                                        <td>{item.salesPerson}</td>
                                                        <td>{moment(item.quoteDate).format("LL")}</td>
                                                        <td>
                                                            <Link to={`/quotes/${item.quoteId}`}>
                                                                {item.quoteId}
                                                            </Link>
                                                        </td>
                                                        <td>{item.customer}</td>
                                                        <td>{item.job}</td>
                                                        <td>
                                                            {item.city}, {item.state}
                                                        </td>
                                                        <td>{numeral(item.price).format("$0,0.00")}</td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                ) : (
                                    <table className="table table-responsive">
                                        <tbody>
                                            <tr>
                                                <td>No results match your criteria.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.props.match.params.query) {
            try {
                let query = Base64.decode(this.props.match.params.query);
                let queryData = JSON.parse(query) as QuerySearch;

                this.setState({
                    quoteId: queryData.quoteId,
                    fromDate: queryData.fromDate ? moment(queryData.fromDate) : undefined,
                    toDate: queryData.toDate ? moment(queryData.toDate) : undefined,
                    customer: queryData.customerId
                        ? { value: queryData.customerId, label: queryData.customerName }
                        : undefined,
                    job: queryData.job,
                    city: queryData.city,
                    product: queryData.productId
                        ? { value: queryData.productId, label: queryData.productName }
                        : undefined,
                    includeArchived: queryData.includeArchived,
                });

                await this.getResults(query);
            } catch { }

            this.setState({
                isLoading: false,
            });
        }

        document.title = "Search - " + SITE_NAME;
    }

    private handleInputChanged(event: React.SyntheticEvent<HTMLInputElement>) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleBooleanInputChanged(
        event: React.SyntheticEvent<HTMLInputElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value === "true",
        } as any);
    }

    private async handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        let data: QuerySearch = {
            fromDate: this.state.fromDate && this.state.fromDate.format(),
            toDate: this.state.toDate && this.state.toDate.format(),
            customerId: this.state.customer && (this.state.customer.value as number),
            customerName: this.state.customer && this.state.customer.label,
            job: this.state.job,
            quoteId: this.state.quoteId,
            city: this.state.city,
            productId: this.state.product && (this.state.product.value as number),
            productName: this.state.product && this.state.product.label,
            includeArchived: this.state.includeArchived,
        };

        let dataJson = JSON.stringify(data);

        this.getResults(dataJson);

        let query = Base64.encode(dataJson);
        this.props.history.push(`/search/${query}`);
    }

    private async getResults(data: string) {
        this.setState({ errorMessage: undefined });
        let response = await apifetch(
            "search",
            {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                method: "POST",
                body: data,
            },
            true
        );

        if (response.ok) {
            let responseData = (await response.json()) as SearchResult[];
            this.setState({
                results: responseData,
            });
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

    private handleFromDateChanged(date: moment.Moment) {
        this.setState({
            fromDate: date,
        });
    }

    private handleToDateChanged(date: moment.Moment) {
        this.setState({
            toDate: date,
        });
    }

    private handleCustomerSelected(value: Option | null) {
        this.setState({
            customer: value !== null ? value : undefined,
        });
    }

    private handleProductSelected(value: Option | null) {
        this.setState({
            product: value !== null ? value : undefined,
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/search/Index.tsx